import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { mediaUrl } from "../lib/media";

export default function ContinueWatchingCard({ entry }) {
    const percent = Math.min(100, Math.max(0, entry.percent || 0));
    const to = entry.link || (entry.type === "episode" ? `/watch/episode/${entry.series_id}/${entry.id}` : `/watch/${entry.type}/${entry.id}`);
    return (
        <Link
            to={to}
            data-testid={`continue-card-${entry.id}`}
            className="group relative shrink-0 w-[320px] snap-start"
        >
            <div className="relative aspect-video rounded-[18px] overflow-hidden bg-white/5 border border-white/5">
                <img
                    src={mediaUrl(entry.thumbnail)}
                    alt={entry.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                <div className="absolute inset-0 flex items-center justify-center">
                    <span className="w-14 h-14 rounded-full bg-black/60 backdrop-blur-md border border-white/20 flex items-center justify-center group-hover:bg-[#FFD400] transition-colors">
                        <Play className="w-6 h-6 fill-white text-white group-hover:fill-black group-hover:text-black translate-x-0.5 transition-colors" />
                    </span>
                </div>
                {/* Progress bar */}
                <div className="absolute bottom-0 inset-x-0 h-1 bg-white/25">
                    <div className="h-full bg-[#FFD400]" style={{ width: `${percent}%` }} />
                </div>
            </div>
            <div className="mt-3 px-1">
                <h3 className="font-display font-semibold text-white leading-snug line-clamp-1">{entry.title}</h3>
                {entry.subtitle && <p className="text-xs text-white/50 mt-0.5">{entry.subtitle}</p>}
            </div>
        </Link>
    );
}
